// src/pages/LoginPage.js

import React, { useState } from 'react';
import { api } from '../config';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { loginUser } from '../api/authApi';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [rememberMe] = useState(false);
  const { handleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from || '/';
  const incomingMessage = location.state?.message || '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
            const data = await loginUser({ email, password, rememberMe });
      handleLogin(data.user, data.accessToken);
      localStorage.setItem('token', data.accessToken);

      const pendingItinerary = sessionStorage.getItem('pendingItinerary');
      const pendingSharedItinerarySave = sessionStorage.getItem('pendingSharedItinerarySave');

      if (pendingItinerary) {
        // Existing behavior: save a normal itinerary after login
        sessionStorage.removeItem('pendingItinerary');
        const parsed = JSON.parse(pendingItinerary);

        fetch(api.url('/api/itinerary/save'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${data.accessToken}`
          },
          body: JSON.stringify(parsed)
        })
          .then((res) => {
            if (!res.ok) throw new Error('Failed to save itinerary');
            navigate('/my-itineraries', { replace: true });
          })
          .catch(() => {
            navigate(from, { replace: true });
          });

      } else if (pendingSharedItinerarySave) {
        // New behavior: save shared itinerary automatically after login
        sessionStorage.removeItem('pendingSharedItinerarySave');
        const parsedShared = JSON.parse(pendingSharedItinerarySave);

        fetch(api.url(`/api/saved-itineraries/shared/${parsedShared.shareId}/save`), {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${data.accessToken}`
          }
        })
          .then(async (res) => {
            const result = await res.json().catch(() => ({}));
            if (!res.ok) {
              throw new Error(
                result?.error ||
                result?.details ||
                result?.message ||
                'Failed to save shared itinerary'
              );
            }
            navigate('/my-itineraries', { replace: true });
          })
          .catch(() => {
            navigate(from, { replace: true });
          });

      } else {
        navigate(from, { replace: true });
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-header">  
      <div className="brand" onClick={() => navigate("/")}>
      <img src="/images/customroam-logo.png" alt="Logo" className="logo-img" />
      <span className="brand-text">CUSTOM ROAM</span>
     </div>
      <div className="back-home" onClick={() => navigate('/')}>
       Back to Home
     </div>
      </div>

    <div className="login-container">
  <h2>Login</h2>

  {incomingMessage && (
    <p className="login-info-message">{incomingMessage}</p>
  )}
      <form onSubmit={handleSubmit} className="login-form">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="login-input"
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="login-input"
        />
         <p className="forgot-password-link">
          <Link to="/forgot-password" className="login-link">Forgot Password?</Link>
         </p>

        

        {error && <p className="login-error">{error}</p>}

        <button type="submit" disabled={loading} className="login-button">
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>

      <p className="login-register-text">
        Don’t have an account?{' '}
        <Link to="/signup" className="login-link">Register one</Link>
      </p>
    </div>
    </div>
  );
};

export default LoginPage;
